<template>
  <div>
    <el-dialog v-model="unbindShow" title="Tips" width="500" :show-close="false" :align-center="true"
            :close-on-click-modal="false">
      <template #header>
        <div class="header">
          剩余支付时间：<span class="surplus_time">{{
            $Tools.convertMinutesToCountdown(countDown)
          }}</span>
        </div>
        <div class="close_icon" @click="clearCountDownInterval('close')">
          <el-icon :size="20">
            <Close />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="flex Flexalign pay_type Flexjustify mar_top_10">
          <div>请使用</div>
          <el-image class="weixin_active_icon mar_left_20" :src="iconPath('weixin_active_icon.png')"
            v-if="payType == 1"></el-image>
          <div class="weixin_text mar_left_10" v-if="payType == 1">微信</div>
          <!-- <div class="mar_left_10">/</div> -->
          <el-image class="weixin_active_icon mar_left_20" :src="iconPath('zhifubao_active_icon.png')"
            v-if="payType == 2"></el-image>
          <div class="zhifubao_text mar_left_10" v-if="payType == 2">支付宝</div>
          <div class="mar_left_10">扫码</div>
        </div>
        <div class="pay_money flex Flexalign Flexjustify mar_top_20">
          <div class="mar_left_10">支付:</div>
          <div class="mar_left_10 pay_active pay_value">{{ orinceTotalPrice }}</div>
          <div class="mar_left_10 pay_active">元</div>
        </div>
        <div class="flex Flexalign Flexjustify qrcode_box">
          <qrcode-vue :value="qrCodeValue" :size="176" v-if="payType == 1"></qrcode-vue>
          <iframe style="width:180px;height:180px;" :srcdoc="qrCodeValue" scrolling="no"
            v-else-if="payType == 2"></iframe>
        </div>
        <!-- <div class="btn_pay cursor_pointer" @click="checkIsPay">{{changeText?"您暂未完成支付，请完成支付后重试":"我已支付"}}</div> -->
        <div class="btn_pay cursor_pointer" @click="checkIsPay" v-if="!changeText">我已支付</div>
        <div class="pay_attention" v-if="changeText">您暂未完成支付，请完成支付后重试</div>
      </div>
    </el-dialog>
    <paySucces ref="paySucces"></paySucces>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import paySucces from "./paySucces.vue";
export default {
  name: "GjkcH5PayDialog",
  components: {
    QrcodeVue,
    paySucces
  },
  props: {
    buyType: {}
  },

  data() {
    return {
      unbindShow: false,
      qrCodeValue: "",
      payType: "",
      orinceTotalPrice: "",
      countDown: 1800, // 三十分钟支付时间
      countDownInterval: "",
      parentId: "", //  订单id
      checkIsPayInterval: "",
      orderType: "",
      changeText: false,
      orderId: '',
      orderNo:'',
    };
  },

  mounted() {
    // this.countDownInterval = setInterval(() => {
    //   this.countDown--;
    //   this.checkOrderIspay();
    //   // 考试时间到清除定时器
    //   if (this.countDown <= 0) {
    //     this.clearCountDownInterval();
    //   }
    // }, 1000);
  },

  methods: {
    startInterval() {
      this.countDownInterval = setInterval(() => {
        this.countDown--;
        // 考试时间到清除定时器
        if (this.countDown <= 0) {
          this.$Dialog.toast("支付超时", { type: "error" });
          this.clearCountDownInterval();
          this.$emit('cancelOrder', this.orderId);
        }
      }, 1000);
      this.checkIsPayInterval = setInterval(() => {
        this.checkOrderIspay();
      }, 3000);
    },
    clearCountDownInterval(type) {
      if (this.countDownInterval) {
        clearInterval(this.countDownInterval);
        this.countDownInterval = "";
      }
      if (this.checkIsPayInterval) {
        clearInterval(this.checkIsPayInterval);
        this.checkIsPayInterval = "";
      }
      this.unbindShow = false;
      if (type == 'close') {
        this.$Jump.href("/orderList", {}, true);
      }
    },
    checkOrderIspay() {
      if (this.buyType != 'examPaper') {
        let listParams = {};
        if (this.orderType == "orderList") {
          listParams = { orderId: this.parentId };
        } else {
          listParams = { parentId: this.parentId };
        }
        this.$Api.shop
          .checkOrderIspay(listParams)
          .then((res) => {
            if (res.data.data.paymentState == 1) {
              this.$Dialog.toast("支付成功");
              this.clearCountDownInterval();
              this.$Jump.href("/paySuccess", { orderId: this.orderId }, true);
            }
          })
          .catch(() => { });
      } else {
        this.$Api.examination
          .checkPaperOrderIspay(this.orderNo)
          .then((res) => {
            if (res.data.data == true) {
              this.$Dialog.toast("支付成功");
              this.clearCountDownInterval();
              this.$refs.paySucces.paySuccessShow = true;
              // this.$Jump.href("/paySuccess", { orderId: this.orderId }, true);
            }
          })
          .catch(() => { });
      }
    },
    checkIsPay() {
      this.changeText = true;
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 490px;
  // height: 528px;
  position: relative;
  padding: 20px;
}

:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}

.header {
  text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;

  //   border-bottom: 1px solid rgba(36, 35, 36, 0.1);
  .surplus_time {
    color: RGBA(19, 214, 170, 1);
  }
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}

.dialog_content {
  .pay_type {
    font-size: 18px;
    color: #333333;

    .weixin_active_icon {
      width: 34px;
      height: 34px;
    }

    .weixin_text {
      color: #2ea31b;
    }

    .zhifubao_text {
      color: #1a89fa;
    }
  }

  .pay_money {
    font-size: 18px;
    color: #333333;

    .pay_value {
      font-weight: bold;
      font-size: 30px;
    }

    .pay_active {
      color: #ff6619;
    }
  }

  .qrcode_box {
    width: 245px;
    height: 232px;
    border: 1px solid #c6cbd4;
    margin: 30px auto;
  }

  .btn_pay {
    width: 190px;
    height: 48px;
    background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
    border-radius: 24px;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 48px;
    margin: 0 auto;
  }

  .pay_attention {
    width: 100%;
    text-align: center;
  }
}
</style>
